import { z } from 'zod';
import { UuidSchema } from '../common/id.js';
import { Iso8601Schema } from '../common/timestamp.js';
export const DeviceLifecycleStateSchema = z.enum([
    'manufactured',
    'tested',
    'sold',
    'registered',
    'active',
    'deactivated',
]);
export const LifecycleActorTypeSchema = z.enum([
    'system',
    'user',
    'erp',
    'production_test',
    'mqtt',
]);
export const DeviceLifecycleEventSchema = z.object({
    id: UuidSchema,
    deviceId: UuidSchema,
    fromState: DeviceLifecycleStateSchema.nullable(),
    toState: DeviceLifecycleStateSchema,
    actorType: LifecycleActorTypeSchema,
    actorId: UuidSchema.nullable(),
    reason: z.string().nullable(),
    metadata: z.record(z.unknown()),
    createdAt: Iso8601Schema,
});
export const DeviceLifecycleHistoryResponse = z.object({
    events: z.array(DeviceLifecycleEventSchema),
});
//# sourceMappingURL=lifecycle.js.map